import React from 'react';
import { sanitize } from 'common/services/sanitizeService';
import './DealDetails.scss';

const DealDetails = ({ dataTestId, title, content }) => {
  return (
    <>
      {!content && (
        <div className="deal-details" data-testid={dataTestId}>
          <div className="deal-details-title">{title}</div>
          <div className={`deal-details-content ${title}`}>-</div>
        </div>
      )}
      {content && (
        <div className="deal-details" data-testid={dataTestId}>
          <div className="deal-details-title">{title}</div>
          <div
            className={`deal-details-content ${title}`}
            lang="en-GB"
            dangerouslySetInnerHTML={{
              __html: sanitize(content),
            }}
          />
        </div>
      )}
    </>
  );
};

export default DealDetails;
